var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.2 17.7L160 32H64C46.3 32 32 46.3 32 64C32 81.7 46.3 96 64 96H448C465.7 96 480 81.7 480 64C480 46.3 465.7 32 448 32H352L344.8 17.7C339.4 6.8 328.3 0 316.2 0H195.8C183.7 0 172.6 6.8 167.2 17.7ZM448 128H64L85.2 467C86.8 492.3 107.8 512 133.1 512H378.9C404.2 512 425.2 492.3 426.8 467L448 128Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.a16b14dfd3a4dd027d27f95257bf0f61.svg";
export { ForwardRef as ReactComponent };